import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  text?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  eyebrow,
  title,
  text,
  align = 'left',
  tone = 'dark'
}: SectionHeadingProps) {
  const isCentered = align === 'center';
  return <div className={['max-w-2xl', isCentered ? 'mx-auto text-center' : ''].join(' ')} data-id="element-124" data-mp="3k187bxhdrcfg">
      {eyebrow && <p className={['font-display text-sm font-bold', tone === 'dark' ? 'text-ember-500' : 'text-ember-300'].join(' ')} data-id="element-125" data-mp="bmgc0fxs43tu">
          {eyebrow}
        </p>}
      <h2 className={['mt-2 font-display text-[1.75rem] font-extrabold leading-[1.15] tracking-tight sm:text-4xl', tone === 'dark' ? 'text-navy-800' : 'text-white'].join(' ')} data-id="element-126" data-mp="6tn79s2b8vhr">
        {title}
      </h2>
      {text && <p className={['mt-4 text-[1.02rem] leading-relaxed', tone === 'dark' ? 'text-navy-500' : 'text-navy-100'].join(' ')} data-id="element-127" data-mp="zb95m5qxhzla">
          {text}
        </p>}
    </div>;
}